import { withErrorContext } from ".";
import { isHotkey } from "is-hotkey";
import { Editor, Transforms } from "slate";

import { RichBlockFormatType, isBlockActive } from "./richText";

export function withOnelineHeaders(editor: Editor): Editor {
  return editor;
}

export const ONELINE_FORMATS: RichBlockFormatType[] = ["heading-one", "heading-two"];

function handleReturnRules(editor: Editor, event: React.KeyboardEvent<HTMLDivElement>): boolean {
  const isOnelineBlock = ONELINE_FORMATS.some(format => isBlockActive(editor, format));

  if (isOnelineBlock) {
    event.preventDefault();
    if (!event.shiftKey) {
      Transforms.splitNodes(editor, {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        match: (node: any) => Editor.isBlock(editor, node),
        always: true,
      });
      Transforms.setNodes(editor, { type: "paragraph" });
    } else {
      editor.insertText("\n");
    }
    return true;
  }
  return false;
}

export const ReactPart = {
  onKeyDown(
    event: React.KeyboardEvent<HTMLDivElement>,
    editor: Editor,
    next: (event: React.KeyboardEvent<HTMLDivElement>) => void
  ): void {
    if (isHotkey("shift?+enter", event.nativeEvent)) {
      const handled = handleReturnRules(editor, event);
      if (!handled) {
        next(event);
      }
    } else {
      next(event);
    }
  },
};

const pluginSpec: import("./index").PluginSpec = [withErrorContext(withOnelineHeaders), ReactPart];
export default pluginSpec;
